import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/Backdrop/Backdrop.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var BackdropWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  top:0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  position: fixed;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-tap-highlight-color: transparent;\n"])), function (props) {
  return props.open ? 'opacity:1; transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;' : 'opacity:0; transition: opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; ';
});